module.exports = __webpack_public_path__ + "img/dd.e66efc06.png";